<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import GameUrlWrapper from '~/components/category/game-url-wrapper.vue';

const settings = useSiteStore();
const auth = useAuthStore();
const gameStore = useGameStore();
const route = useRoute();
const router = useRouter();

const game = gameStore.returnCurrentGame;

const handleConfirm = () => {
  settings.deactivateModal();
  if (route?.query?.depositOnLaunch) auth.setAccountModalPage('deposit');
};

const handleDecline = () => {
  settings.deactivateModal();
  settings.setDemoPlayTimeout();
  if (route?.query?.depositOnLaunch) router.push('?dp=true');
};

onMounted(() => settings.clearDemoPlayTimeout());
</script>

<template>
  <div class="p-4 flex flex-col gap-2">
    <p class="text-base-priority">
      {{ $t('acknowledge-real-play-body') }}
    </p>
  </div>
  <div class="grid grid-cols-2 gap-4 p-4 bg-base w-full">
    <Button
      type="secondary-alternative"
      class="w-full justify-center"
      @click="handleDecline"
    >
      {{ $t('decline-real-play') }}
    </Button>
    <GameUrlWrapper :game="game" @click="handleConfirm">
      <Button type="primary" class="w-full justify-center">
        {{ $t('confirm') }}
      </Button>
    </GameUrlWrapper>
  </div>
</template>
